// helpers
import getRootSaga from '@utils/getRootSaga';
import { saga as shm } from '@features/shm';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const sagas: any[] = [shm];

export default getRootSaga(sagas);
